import { useQuery } from '@tanstack/react-query';
import { api } from 'constants/api';

import { ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type MessageTemplateType = {
  campaign_id: string;
  channel: 'sms' | 'email' | 'push';
  message: string;
  name: string;
  tags: string[];
  title?: string;
};

export type MessageTemplateResponseType = MessageTemplateType[];

export const useGetMessagesTemplates = (
  channel: 'sms' | 'email' | 'push',
  options: QueryOptions<MessageTemplateResponseType> = {}
) =>
  useQuery({
    queryFn: async (): Promise<MessageTemplateResponseType> => {
      const params = new URLSearchParams();

      if (channel) {
        params.append('channel', channel);
      }

      const { data } = await api.get<ApiResponse<MessageTemplateResponseType>>(
        `/campaign/templates/list?${params.toString()}`
      );

      return data.data;
    },
    queryKey: ['templates-list', channel],
    ...options,
  });
